module.exports = __webpack_public_path__ + "static/BeVietnam-Light-fc20d70f8d84f3989f632e1d5a81925e.woff";